import React from "react";
import { node } from "prop-types";
import Section from "../Section";
import { Container, Row } from "../Grid";

const PageNavbarSearch = ({ children }) => {
	return (
		<Section spacing={{ py: 3 }} utility={{ bgColor: "black--10" }}>
			<Container>
				<Row utility={{ align: { items: "center" }, justify: "center" }}>{children}</Row>
			</Container>
		</Section>
	);
};

PageNavbarSearch.propTypes = {
	children: node.isRequired,
};

export default PageNavbarSearch;
